import { observable, action } from 'mobx';
import { Guarantors } from 'api';

class GuarantorsStore {
  @observable guarantors = [];

  @observable fetchState;

  anketId;

  @action.bound
  async getGuarantors(anketId) {
    if (this.anketId === anketId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Guarantors.getGuarantors(anketId);
      this.guarantors = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const guarantorsStore = new GuarantorsStore();

export default guarantorsStore;
